import gql from "graphql-tag";

export default gql`
  mutation createUserRecord(
    $userPoolId: ID!
    $username: String!
    $type: String!
    $origin: String
  ) {
    createUserRecord(
      userPoolId: $userPoolId
      username: $username
      type: $type
      origin: $origin
    ) {
      identityId
      userPoolId
      username
      type
      origin
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/CreateUserRecord.js